<template>
    <fieldset class="fieldset audience-option">
        <legend>Аудиторные данные</legend>
        <label class="field checkbox-field audience-option__check">
            <input
                type="checkbox"
                class="creative-checkbox"
                :checked="enabled"
                :disabled="disabled"
                @change="onToggle($event)"
            />
            <span>Добавить аудиторные данные</span>
        </label>
        <p class="audience-option__note">
            Наценка за покупку аудиторных данных: {{ markupPercent }}%.
            Выбирая покупку, вы соглашаетесь с
            <a :href="offerUrl" target="_blank" rel="noopener noreferrer">офертой</a>.
            Ставка на аукцион не меняется — {{ markupPercent }}% добавляются к счёту.
            Контакты у экрана (OTS) считаются по 15-минутным интервалам: несколько выходов в одном интервале не увеличивают цифру.
            Ролик по-прежнему видит любой, кто смотрит на экран.
        </p>
        <p v-if="!canEnable && !locked && !enabled" class="section-hint section-hint--warn">
            Аудиторные данные можно включить только при создании или в черновике.
        </p>
        <p v-else-if="!hasBeeline && !locked" class="section-hint section-hint--warn">
            Среди выбранных экранов нет площадок с аудиторными данными — опцию включить нельзя.
        </p>
        <p v-if="enabled && payableHint" class="audience-option__payable">
            {{ payableHint }}
        </p>
        <p v-if="preview && enabled" class="audience-option__preview">
            Плановые контакты:
            <strong>{{ formatOts(preview.ots) }}</strong>
            <span v-if="qualityLabel"> · {{ qualityLabel }}</span>
            <span v-if="preview.source_month"> · источник {{ preview.source_month }}</span>
        </p>
    </fieldset>
</template>

<script>
import { confirmAction } from '../../../composables/useConfirm';

export default {
    name: 'AudienceDataOption',
    props: {
        enabled: { type: Boolean, default: false },
        locked: { type: Boolean, default: false },
        hasBeeline: { type: Boolean, default: false },
        canEnable: { type: Boolean, default: true },
        canWrite: { type: Boolean, default: true },
        markupPercent: { type: Number, default: 10 },
        offerUrl: { type: String, default: '#' },
        payableHint: { type: String, default: '' },
        preview: { type: Object, default: null },
    },
    emits: ['update:enabled'],
    computed: {
        disabled() {
            return !this.canWrite || this.locked || (!this.enabled && (!this.hasBeeline || !this.canEnable));
        },
        qualityLabel() {
            const q = this.preview?.quality;
            if (q === 'actual') return 'факт';
            if (q === 'projected') return 'оценка';
            if (q === 'mixed') return 'оценка + факт';
            return '';
        },
    },
    methods: {
        async onToggle(event) {
            const checkbox = event.target;
            if (!checkbox.checked) {
                if (this.locked) {
                    checkbox.checked = true;
                    return;
                }
                this.$emit('update:enabled', false);
                return;
            }
            checkbox.checked = false;
            const isConfirmed = await confirmAction({
                title: 'Включить аудиторные данные?',
                message: `К счёту добавится ${this.markupPercent}%.\nПосле сохранения кампании отключить опцию будет нельзя.`,
                confirmLabel: 'Включить',
            });
            if (isConfirmed) this.$emit('update:enabled', true);
        },
        formatOts(value) {
            const n = Number(value);
            if (!Number.isFinite(n) || n <= 0) return 'нет данных';
            return new Intl.NumberFormat('ru-RU').format(Math.round(n));
        },
    },
};
</script>

<style scoped lang="scss">
.audience-option__check {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    cursor: pointer;
}

.creative-checkbox {
    width: 18px;
    height: 18px;
    min-width: 18px;
    min-height: 18px;
    margin: 0;
    padding: 0;
    accent-color: #2563eb;
    flex-shrink: 0;
    cursor: pointer;

    &:disabled {
        cursor: not-allowed;
    }
}
</style>
